export const SECTION_SUBHEADER_FONTSIZE = 15;
export const NAVBAR_FONTSIZE = 14 / 16; // rem
export const SECTION_ANIMATION_DURATION = 0.5; //seconds
export const SECTION_ANIMATION_DELAY = 0.1; // seconds
